<template>
  <div
    class="rich-html-page"
    :class="pageConfig ? `rich-html-page--${caseName}` : ''"
    :style="pageBackgroundStyle"
  >
    <div v-if="!pageConfig" class="rich-html-page__state">
      <p>案例不存在或已下线</p>
      <button type="button" class="rich-html-page__back" @click="goBack">
        返回案例列表
      </button>
    </div>

    <component v-else :is="pageConfig.component" :key="caseName" />
  </div>
</template>

<script setup>
import { computed, getCurrentInstance, onMounted, watch } from "vue";
import { richHtmlCaseMap } from "./data";

const { proxy } = getCurrentInstance();

const caseName = computed(() => proxy.$route.params.caseName);
const pageConfig = computed(() => richHtmlCaseMap[caseName.value] || null);

const pageBackgroundStyle = computed(() => {
  if (!pageConfig.value || !pageConfig.value.bgColor) {
    return {};
  }

  return { backgroundColor: pageConfig.value.bgColor };
});

const goBack = () => {
  proxy.$router.push("/case");
};

const syncPageMeta = () => {
  if (!pageConfig.value) {
    return;
  }

  document.title = `${pageConfig.value.title} - 云效科技`;
  window.scrollTo({ top: 0 });
};

watch(caseName, () => {
  syncPageMeta();
});

onMounted(() => {
  syncPageMeta();
});
</script>

<style lang="scss">
.rich-html-page {
  width: 100%;
  min-height: 100%;
}

.rich-html-case {
  width: 100%;
  min-height: 100%;
}

.rich-html-case img[src=""],
.rich-html-case img:not([src]) {
  display: none;
}

.rich-html-page__state {
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: #4b5563;
  font-size: 16px;
}

.rich-html-page__back {
  border: none;
  border-radius: 20px;
  padding: 10px 24px;
  background: #2f6ffd;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
}

/* 滚动入场动画：不改变布局，仅控制显隐过渡 */
.rich-html-case .hero,
.rich-html-case .section,
.rich-html-case section.overview,
.rich-html-case section.features,
.rich-html-case section.ui-showcase,
.rich-html-case section.tech-specs,
.rich-html-case section.user-value,
.rich-html-case section.project-intro,
.rich-html-case section.poster-banner,
.rich-html-case section.page-summary,
.rich-html-case section.related-cases,
.rich-html-case section.background-section,
.rich-html-case section.showcase-section,
.rich-html-case section.features-section,
.rich-html-case section.specs-section,
.rich-html-case section.reviews-section,
.rich-html-case section.showcase,
.rich-html-case section.screens-section {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.6s ease, transform 0.6s ease;
}

.rich-html-case .hero.revealed,
.rich-html-case .section.revealed,
.rich-html-case section.revealed {
  opacity: 1;
  transform: translateY(0);
}

/* 深色案例页：首屏 hero 默认可见，避免白屏 */
.rich-html-page--intelligentElectricAdjustmentSystem .rich-html-case .hero,
.rich-html-page--intelligentElectricAdjustmentSystem .rich-html-case .project-intro {
  opacity: 1;
  transform: translateY(0);
}

/* 浅色案例页：首屏 hero / 项目介绍默认可见 */
.rich-html-page--intelligentPetFeeder .rich-html-case .hero,
.rich-html-page--intelligentPetFeeder .rich-html-case .project-intro {
  opacity: 1;
  transform: translateY(0);
}

.rich-html-page--lovableHome .rich-html-case .poster-banner,
.rich-html-page--lovableHome .rich-html-case .project-intro {
  opacity: 1;
  transform: translateY(0);
}

.rich-html-page--channelAdvertisingFundManagementPlatform .rich-html-case .poster-banner,
.rich-html-page--channelAdvertisingFundManagementPlatform .rich-html-case .project-intro {
  opacity: 1;
  transform: translateY(0);
}

.rich-html-page--geneticMetabolicBrainWhiteMatterJudgmentSystem .rich-html-case .poster-banner,
.rich-html-page--geneticMetabolicBrainWhiteMatterJudgmentSystem .rich-html-case .project-intro {
  opacity: 1;
  transform: translateY(0);
}
</style>
